var map = {
	"./gmc1.jpg": 4330,
	"./gmc10.jpg": 2680,
	"./gmc2.jpg": 6933,
	"./gmc3.jpg": 9768,
	"./gmc4.jpg": 9771,
	"./gmc5.jpg": 1934,
	"./gmc6.jpg": 5017,
	"./gmc7.jpg": 6972,
	"./gmc8.jpg": 8687,
	"./gmc9.jpg": 6306,
	"./plasticpollution1.jpg": 5655,
	"./plasticpollution2.jpg": 2808,
	"./plasticpollution3.jpg": 3989,
	"./plasticpollution4.jpg": 574,
	"./plasticpollution5.jpg": 6411,
	"./plasticpollution6.jpg": 1244,
	"./savedeeporbeel1.jpg": 7259,
	"./savedeeporbeel2.jpg": 9564,
	"./savedeeporbeel3.jpg": 3289
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 967;